import { useEffect, useState } from 'react'
import { isSupabaseConfigured } from '@/lib/supabase'

export interface UseSupabaseResult<T> {
  data: T | null
  loading: boolean
  error: Error | null
  refetch: () => Promise<void>
}

export function useSupabase<T>(
  queryFn: () => Promise<T>,
  dependencies: unknown[] = [],
  immediate = true
): UseSupabaseResult<T> {
  const [data, setData] = useState<T | null>(null)
  const [loading, setLoading] = useState(immediate)
  const [error, setError] = useState<Error | null>(null)

  const executeQuery = async () => {
    if (!isSupabaseConfigured()) {
      setError(new Error('Supabase não configurado'))
      setLoading(false)
      return
    }

    try {
      setLoading(true)
      setError(null)
      const result = await queryFn()
      setData(result)
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (immediate) {
      executeQuery()
    }
  }, dependencies)

  return {
    data,
    loading,
    error,
    refetch: executeQuery
  }
}

